import type { Pinia } from 'pinia'
import { setStoredToken } from '@/utils/http'
import { useEntryParamsStore } from '@/stores/entry-params'
import type { H5EntryParamsPatch, ScenePlayH5Entry } from '@/types/h5-entry'

function parsePositiveInt(value: string | null): number | null {
  if (!value?.trim()) {
    return null
  }

  const parsed = Number.parseInt(value, 10)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null
}

function parseOptionalString(value: string | null): string | null {
  const trimmed = value?.trim()
  return trimmed ? trimmed : null
}

function parseEntry(value: string | null): ScenePlayH5Entry | null {
  if (value === 'continue' || value === 'view-result') {
    return value
  }
  return null
}

export function parseEntryParamsFromUrl(href: string = window.location.href): H5EntryParamsPatch {
  const searchParams = new URL(href).searchParams

  return {
    sceneId: parsePositiveInt(searchParams.get('sceneId')),
    playerSceneId: parsePositiveInt(searchParams.get('playerSceneId')),
    materialKey: parseOptionalString(searchParams.get('materialKey')),
    capturedUrl: parseOptionalString(searchParams.get('capturedUrl')),
    productUrl: parseOptionalString(searchParams.get('productUrl')),
    playType: parseOptionalString(searchParams.get('playType')),
    entry: parseEntry(searchParams.get('entry')),
    shareToken: parseOptionalString(searchParams.get('shareToken')),
    joinedSlotKey: parseOptionalString(searchParams.get('joinedSlotKey')),
  }
}

export function initAuthFromEntryUrl(href: string = window.location.href): boolean {
  const token = new URL(href).searchParams.get('token')
  if (!token?.trim()) {
    return false
  }

  setStoredToken(token)
  return true
}

export function initEntryParamsFromUrl(pinia: Pinia, href: string = window.location.href): boolean {
  const params = parseEntryParamsFromUrl(href)
  const hasParams = Object.values(params).some((value) => value != null)
  if (!hasParams) {
    return false
  }

  useEntryParamsStore(pinia).patch(params)
  return true
}

/** 小程序 web-view 初次进入：token 写 sessionStorage，其余参数写 Pinia 并持久化 */
export function initH5Entry(pinia: Pinia, href: string = window.location.href): void {
  initAuthFromEntryUrl(href)
  initEntryParamsFromUrl(pinia, href)
}
